import { sagas as guestsSagas } from './modules/guests'

export default [...guestsSagas]
